import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Withdraw.css';

interface Network {
  id: string;
  name: string;
}

const mockNetworks: Network[] = [
  { id: 'ton', name: 'TON' },
  { id: 'polygon', name: 'POLYGON' },
  { id: 'arbitrum', name: 'ARBITRUM' },
  { id: 'sol', name: 'SOL' },
  { id: 'near', name: 'NEAR' },
  { id: 'trc20', name: 'TRC20' },
];

const Withdraw: React.FC = () => {
  const navigate = useNavigate();
  const [selectedCrypto, setSelectedCrypto] = useState('BTC');
  const [selectedNetwork, setSelectedNetwork] = useState(mockNetworks[5]);
  const [amount, setAmount] = useState('0');
  const [walletAddress, setWalletAddress] = useState('0x19b4fd8f1f3acf094361abf777acd840ab8e1d47');
  const [includeFeesInAmount, setIncludeFeesInAmount] = useState(true);

  const handleBack = () => {
    navigate(-1);
  };

  const handleBuyCrypto = () => {
    console.log('Navigate to buy crypto');
  };

  const handleHistory = () => {
    navigate('/history-withdrawal');
  };

  const handleMaxAmount = () => {
    setAmount('0.00024');
  };

  const handleWithdraw = () => {
    console.log('Process withdrawal');
  };

  const minAmount = '10';
  const maxAmount = '0.00024';

  return (
    <div className="withdraw-container">
      {/* Header */}
      <header className="withdraw-header">
        <button className="withdraw-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div className="withdraw-header-actions">
          <button className="withdraw-header-button" onClick={handleBuyCrypto}>
            <span className="withdraw-header-button-icon">+</span>
            <span>Buy Crypto</span>
          </button>
          <button className="withdraw-header-button" onClick={handleHistory}>
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M5.5 1V5.5L8.25 8.25" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="5.5" cy="5.5" r="4.5" stroke="currentColor" strokeWidth="1.2"/>
            </svg>
            <span>History</span>
          </button>
        </div>
      </header>

      <div className="withdraw-content">
        {/* Title */}
        <h1 className="withdraw-title">Withdraw</h1>

        {/* Currency Selection */}
        <div className="withdraw-section">
          <label className="withdraw-label">Currency</label>
          <button className="withdraw-crypto-selector">
            <div className="withdraw-crypto-info">
              <div className="withdraw-crypto-icon">₿</div>
              <span className="withdraw-crypto-symbol">{selectedCrypto}</span>
            </div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Network Selection */}
        <div className="withdraw-section">
          <label className="withdraw-label">Select Network</label>
          <div className="withdraw-network-grid">
            {mockNetworks.map((network) => (
              <button
                key={network.id}
                className={`withdraw-network-button ${selectedNetwork.id === network.id ? 'active' : ''}`}
                onClick={() => setSelectedNetwork(network)}
              >
                {network.name}
              </button>
            ))}
          </div>
        </div>

        {/* Amount Input */}
        <div className="withdraw-section">
          <label className="withdraw-label">Amount</label>
          <div className="withdraw-amount-container">
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="withdraw-amount-input"
              placeholder="0"
            />
            <button className="withdraw-max-button" onClick={handleMaxAmount}>
              Max
            </button>
            <span className="withdraw-currency-label">{selectedCrypto}</span>
          </div>
          <div className="withdraw-limits">
            <span className="withdraw-limit">Minimum: <span className="withdraw-limit-value">{minAmount} {selectedCrypto}</span></span>
            <span className="withdraw-limit">Maximum: <span className="withdraw-limit-max">{maxAmount} {selectedCrypto}</span></span>
          </div>
        </div>

        {/* Wallet Address Input */}
        <div className="withdraw-section">
          <label className="withdraw-label">Wallet Address</label>
          <input
            type="text"
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
            className="withdraw-address-input"
            placeholder="Enter wallet address"
          />
        </div>

        {/* Include Fees Checkbox */}
        <div className="withdraw-checkbox-container">
          <label className="withdraw-checkbox-label">
            <input
              type="checkbox"
              checked={includeFeesInAmount}
              onChange={(e) => setIncludeFeesInAmount(e.target.checked)}
              className="withdraw-checkbox"
            />
            <span className="withdraw-checkbox-custom">
              {includeFeesInAmount && (
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
                  <path d="M2 8L5 11L12 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </span>
            <span className="withdraw-checkbox-text">Include fees in amount</span>
          </label>
        </div>

        {/* Withdraw Button */}
        <button 
          className="withdraw-submit-button" 
          onClick={handleWithdraw}
          disabled={!amount || amount === '0'}
        >
          Withdraw
        </button>
      </div>
    </div>
  );
};

export default Withdraw;